import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, setSessionToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data.user);
        setSessionToken(r.data.session_token);
        try { localStorage.setItem("omni_token", r.data.session_token); } catch {}
        navigate("/app", { replace: true, state: { user: r.data.user } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser, setSessionToken]);

  return <div className="min-h-screen flex items-center justify-center font-mono text-sm">AUTHENTICATING…</div>;
};

export default AuthCallback;
